import React from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';

const Contact = ({ fieldData, setFieldData, formErrors, setFormErrors }) => {
  return (
    <TextInput
      type="tel"
      label="Contact Number *"
      pattern="[0-9]{10}"
      maxLength="10"
      value={fieldData.contactNumber}
      error={
        'contactNumber' in formErrors ? formErrors.contactNumber.message : undefined
      }
      onChange={(value) => {
        if (!value)
          setFormErrors({
            ...formErrors,
            contactNumber: { message: 'Field is required' }
          });
        else if (!/^[0-9]{10}/.test(value)) {
          setFormErrors({
            ...formErrors,
            contactNumber: { message: 'Please enter a valid 10 digit number' }
          });
        } else {
          const errors = { ...formErrors };
          delete errors.contactNumber;
          setFormErrors({
            ...errors
          });
        }
        setFieldData(previousValue => ({
          ...previousValue,
          contactNumber: value
        }));
      }}
    />
  );
};

Contact.propTypes = {
  formErrors: PropTypes.shape({
    contactNumber: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default Contact;
